export default async function ({ store, redirect }) {
    // If the user is not authenticated
    if (!store.state.user.isLoggedIn) {
      return redirect('/my-account/')
    }
  }